const Footer = () => {
  return (
    <footer className="border-t border-slate-200 bg-white text-slate-400 text-center px-4 py-4 text-xs mt-auto">
      © 2026 FPL Nepal · Season 16 · 2026/27
    </footer>
  );
};

export default Footer;
